// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"42d6f754","492":"841b1444","714":"bc58b2c3"}[chunkId] + ".chunk.css";
};